var map = {
	"./horizontal-bg-black.jpg": 90912,
	"./horizontal-bg-blue.jpg": 13197,
	"./horizontal-bg-gray.jpg": 50996,
	"./horizontal-bg-orange.jpg": 89095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78028;